import { React, useState, useEffect } from 'react';
import TOPBAR from "../../components/TopBar";
import SEARCHBAR from "../../components/SeachBar";
import MENUBAR from "../../components/Menu";
import FOOTER from "../../components/Footer";







export default function Index() {
    const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;
    const [isHidden, setIsHidden] = useState(false);
    const [showMenuSide, setShowMenuSide] = useState("");
    const [cartItems, setCartItems] = useState("");

    const [showMessage, setShowMessage] = useState(false);
    const [showSuccessMessage, setSuccessShowMessage] = useState(false);


    useEffect(() => {
        const storedCartItems = localStorage.getItem('totalCartItems');
        if (storedCartItems) {
            const parsedCartItems = JSON.parse(storedCartItems);
            const numCartItems = Object.values(parsedCartItems);
            const sum = numCartItems.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
            setCartItems(sum);
        }
        setTimeout(() => {
            setIsHidden(true);
        }, 2000);

    }, []);


    const showLoaderLine = (id) => {
        if (id === 1) {
            setIsHidden(false);
        } else {
            setIsHidden(true);
        }

    };

    const setValueMenuSideBar = (value) => {
        setShowMenuSide(value)
    }

    const [email, setEmail] = useState('');
    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            const response = await fetch(`${mainUrl}/api/forgot-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email })
            });

            if (response.ok) {
                setShowMessage(false);
                setSuccessShowMessage(true)
            } else {
                setShowMessage(true);
                setSuccessShowMessage(false)
            }
        } catch (error) {
            console.error('Error sending reset email:', error);
            setSuccessShowMessage(false);
            setShowMessage(false);
        }
    };

    return (
        <>
            <TOPBAR isHidden={isHidden} />
            <SEARCHBAR setValueMenuSideBar={setValueMenuSideBar} cartItemsdata={cartItems} />
            <MENUBAR showMenuSide={showMenuSide} setValueMenuSideBar={setValueMenuSideBar} />
            <section>
                <div className="main-section-lsting mainDivForgetPassord">
                    <div className="container ">


                        {
                            showMessage ?
                                <div className='errorMessageDiv'>
                                    <span>
                                        "User not found. Please check your email!"
                                    </span>
                                </div>

                                : ""
                        }
                        {
                            showSuccessMessage ?
                                <div className='suessMessageDiv'>
                                    <span>
                                        "Password reset email sent successfully!. Please check your email!"
                                    </span>
                                </div>

                                : ""
                        }

                        <div className='row forgotPassword'>
                            <div className="col-lg-12">
                                <div>
                                    <h2>Forgot Password</h2>
                                    <form onSubmit={handleSubmit}>
                                        <label>Email:</label>
                                        <input type="email" value={email} onChange={handleEmailChange} required className='form-control' />
                                        <button type="submit" className='btn btn-danger btn-sm'>Reset Password</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            < FOOTER />
        </>

    )
}
